module.exports = __webpack_public_path__ + "static/media/rain.075febfd.svg";